export const populateVoiceList = (language) => {
  const synth = speechSynthesis;
  const voices = synth.getVoices();
  const lang = language ?? 'fr-FR';
  let optionsVoice = [];
  const filteredVoices = voices.filter((voice) => voice.lang == lang);

  for (let i = 0; i < filteredVoices?.length; i++) {
    let option = {
      id: filteredVoices[i].name,
      label: filteredVoices[i].name,
    };
    optionsVoice = [...optionsVoice, option];
  }

  return optionsVoice;
};
